/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { DestroyRef, Directive, inject, Input, OnInit, SkipSelf, ViewContainerRef } from '@angular/core';
import { AbstractControlDirective, ControlContainer, FormGroupDirective, NgControl, NgForm, PristineChangeEvent, StatusChangeEvent, TouchedChangeEvent } from '@angular/forms';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { debounceTime, delay, EMPTY, filter, merge } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

//TODO rename to iriroFormInlineError
@Directive({
  selector: '[sharedUiFormInlineError], [formInlineError]',
  standalone: true,
})
export class FormInlineErrorDirective implements OnInit {
  @Input('formInlineError') errorPath: string  | null = null;

  private directiveControl: AbstractControlDirective | null =
    inject(NgControl, {
      optional: true,
      self: true,
    }) ||
    inject(ControlContainer, { optional: true, self: true }) ||
    null;

  private readonly destroyRef = inject(DestroyRef);
  private readonly ngForm = inject(NgForm, { optional: true });
  private readonly formGroupDirective = inject(FormGroupDirective, { optional: true });
  constructor(@SkipSelf() private readonly container: ViewContainerRef) {}

  ngOnInit(): void {
    const componentRef = this.container.createComponent<ErrorMessageComponent>(ErrorMessageComponent);
    if(this.directiveControl) {
      componentRef.setInput('control', this.directiveControl);
    }
    if(this.errorPath) {
      componentRef.setInput('errorPath', this.errorPath);
    }
    componentRef.setInput('stateVersion', Date.now());

    const control = this.directiveControl?.control;
    if (!control) {
      return;
    }

    const submitEvent$ = (this.formGroupDirective?.ngSubmit ?? this.ngForm?.ngSubmit)
      ?.pipe(delay(0)) ?? EMPTY;

    merge(
      control.events.pipe(
        filter(e =>
          e instanceof TouchedChangeEvent ||
          e instanceof PristineChangeEvent ||
          e instanceof StatusChangeEvent
        )
      ),
      submitEvent$,
    )
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(100)
        )
      .subscribe(() => {
        componentRef.setInput('stateVersion', Date.now());
      });

  }
}
